import type { Messages } from '../catalogue.en'

/**
 * Processings: long work over a Patient's material that any member who may
 * read it can follow, stop and remove — the workspace tile, the registry, the
 * page of one processing and the names of its closed lists.
 *
 * Composed into the public catalogue by `catalogue.ru.ts`. Nothing imports
 * this module directly: consumers ask the catalogue.
 */
export const processing: Partial<Messages> = {
  'processing.title': 'Обработки',
  'processing.kind.externalEntries': 'Записи ЭМК из документов',
  'processing.status.queued': 'В очереди',
  'processing.status.running': 'Выполняется',
  'processing.status.needsAction': 'Ждёт действия',
  'processing.status.failed': 'Ошибка',
  'processing.status.succeeded': 'Завершена',
  'processing.status.cancelled': 'Отменена',
  'processing.stage.externalEntries.recognizing': 'Распознавание текста',
  'processing.stage.externalEntries.segmenting': 'Разметка страниц',
  'processing.stage.externalEntries.grouping': 'Поиск событий',
  'processing.stage.externalEntries.extracting': 'Заполнение записей',
  'processing.stage.externalEntries.review': 'Проверка',
  'processing.tileDescription': 'Распознавание и разбор документов пациентов',
  'processing.itemTitle': 'Обработка',
  'processing.columnKind': 'Вид',
  'processing.columnPatient': 'Пациент',
  'processing.columnSubject': 'Файлы',
  'processing.columnRequester': 'Запустил',
  'processing.columnStarted': 'Начато',
  'processing.columnStage': 'Этап и ход',
  'processing.columnStatus': 'Статус',
  'processing.columnUpdated': 'Обновлено',
  'processing.columnActions': 'Действия',
  'processing.filterMine': 'Мои',
  'processing.loading': 'Загрузка обработок',
  'processing.loadFailed': 'Не удалось загрузить обработки.',
  'processing.empty': 'Обработок пока нет',
  'processing.emptyDetail': 'Обработка запускается из файлов пациента: отметьте документы и выберите, что с ними сделать.',
  'processing.filteredEmpty': 'Нет обработок, соответствующих фильтрам',
  'processing.filteredEmptyDetail': 'Сначала показаны незавершённые обработки; очистите фильтр «Статус», чтобы увидеть все.',
  'processing.resultCountOne': '{count} обработка',
  'processing.resultCountMany': 'Обработок: {count}',
  'processing.progress': '{done} из {total}',
  'processing.awaiting': 'На проверке: {count}',
  'processing.cancel': 'Отменить',
  'processing.remove': 'Удалить',
  'processing.cancelNamed': 'Отменить обработку {name}',
  'processing.removeNamed': 'Удалить обработку {name}',
  'processing.cancelTitle': 'Отменить обработку?',
  'processing.cancelDetail': 'Новые шаги не начнутся. То, что уже сохранено в карту, останется.',
  'processing.cancelKeep': 'Не отменять',
  'processing.cancelConfirm': 'Отменить обработку',
  'processing.cancelFailed': 'Не удалось отменить обработку. Попробуйте ещё раз.',
  'processing.removeTitle': 'Удалить обработку?',
  'processing.removeDetail': 'Обработка исчезнет из списка у всех. То, что она сохранила в карту, останется.',
  'processing.removeKeep': 'Не удалять',
  'processing.removeConfirm': 'Удалить обработку',
  'processing.removeFailed': 'Не удалось удалить обработку. Попробуйте ещё раз.',
  'processing.actChanged': 'Обработка тем временем изменилась, теперь показано её текущее состояние.',
  'processing.actGone': 'Этой обработки больше нет.',
  'processing.invalidLink': 'Ссылка на обработку недействительна',
  'processing.invalidLinkDetail': 'Откройте обработку заново из списка «Обработки».',
  'processing.notFound': 'Обработка не найдена',
  'processing.notFoundDetail': 'Возможно, её удалили или у вас нет к ней доступа.',
  'processing.loadingOne': 'Загрузка обработки',
  'processing.factFinished': 'Окончена',
  'processing.factCancelledBy': 'Отменил',
  'processing.unknownKind': 'Эта версия приложения не умеет показывать подробности такой обработки.',
  'processing.patientLabel': 'Пациент',
}
